export default __webpack_public_path__ + "static/media/money-back.2ed26b22.png";